import { cn, formatNumber } from '@/lib/utils'

interface StatCardProps {
  label: string
  value: number
  subtitle?: string
  trend?: { value: number; label: string }
  className?: string
}

export function StatCard({ label, value, subtitle, trend, className }: StatCardProps) {
  return (
    <div className={cn('rounded-lg border border-dashed border-border bg-surface p-5', className)}>
      <p className="font-mono text-[11px] tracking-wider text-ink-faint uppercase">{label}</p>
      <p className="mt-2 font-mono text-2xl font-semibold tabular-nums text-ink">
        {formatNumber(value)}
      </p>
      {subtitle && <p className="mt-1 font-mono text-[11px] text-ink-faint">{subtitle}</p>}
      {trend && (
        <p
          className={cn(
            'mt-2 font-mono text-[11px]',
            trend.value >= 0 ? 'text-positive' : 'text-negative'
          )}
        >
          {trend.value >= 0 ? '+' : ''}
          {trend.value}% {trend.label}
        </p>
      )}
    </div>
  )
}
